<template>
  <div v-if="!!message" :class="[type]">
    <span>
      {{ message }}fghiop
    </span>
  </div>
</template>

<script>
import { MESSAGE_TIMEOUT } from '@/constants'

export default {
  name: 'Message',
  props: {
    text: String,
    type: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      message: ''
    }
  },
  watch: {
    text (value) {
      this.message = value
    },
    message (value) {
      if (this.text === value) {
        setTimeout(() => {
          this.message = ''
        }, MESSAGE_TIMEOUT)
      }
    }
  }
}
</script>

<style scoped>
  .warning {
    color: #ffc107 !important
  }

  .error {
    color: #dc3545 !important;
  }

  .success {
    color: #28a745 !important
  }

  .primary {
    color: #007bff !important
  }

  .info {
    color: #17a2b8 !important
  }
</style>
